import { Bounds } from "../engine/space/bounds";
import { RDisplay } from "./RotDisplay";

export const floodFill = (display: RDisplay, o: Bounds, bg: string) => {
  const right = o.x + o.w;
  const bottom = o.y + o.h;
  for (let y = o.y; y < bottom; y++) {
    for (let x = o.x; x < right; x++) {
      display.draw(x, y, " ", null, bg);
    }
  }
};

export const borderFill = (display: RDisplay, o: Bounds) => {
  const right = o.x + o.w - 1;
  const bottom = o.y + o.h - 1;

  display.draw(o.x, o.y, "+", null, null);
  display.draw(o.x, bottom, "+", null, null);
  display.draw(right, o.y, "+", null, null);
  display.draw(right, bottom, "+", null, null);

  for (let y = o.y + 1; y < bottom; y++) {
    display.draw(o.x, y, "|", null, null);
    display.draw(right, y, "|", null, null);
  }
  for (let x = o.x + 1; x < right; x++) {
    display.draw(x, o.y, "-", null, null);
    display.draw(x, bottom, "-", null, null);
  }
};

export const lineDraw = (display: RDisplay, o: Bounds, text?: string) => {
  const right = o.x + o.w - 1;
  for (let x = o.x; x <= right; x++) {
    display.draw(x, o.y, "-", null, null);
  }

  if (text) {
    const center = o.x + Math.floor((o.w - text.length) / 2);
    const lx = Math.max(o.x, center);
    display.drawText(lx, o.y, text);
  }
};

export const vertLineDraw = (display: RDisplay, o: Bounds) => {
  const bot = o.y + o.h - 1;
  for (let y = o.y; y <= bot; y++) {
    display.draw(o.x, y, "|", null, null);
  }
};
